import { render } from "./customMenu.vue?vue&type=template&id=bdf12d8e&scoped=true"
import script from "./customMenu.vue?vue&type=script&lang=js"
export * from "./customMenu.vue?vue&type=script&lang=js"

import "./customMenu.vue?vue&type=style&index=0&id=bdf12d8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf12d8e"]])

export default __exports__